export const ITipAnalyticsEventsRepositoryType = Symbol('ITipAnalyticsEventsRepository');
